import { isTimeSignature } from '../TimeSignature';
export function isMusicSheet(x) {
    return x != null &&
        (Array.isArray(x.segments) && x.segments.every(isMusicSheetSegment));
}
export function isStickingComplete(sheet) {
    return !sheet.segments.some(({ measures }) => measures.some(({ notes }) => notes.some(note => isChordTuplet(note)
        ? note.chords.some(chord => chord.some(h => h.pitch != null && h.sticking == null))
        : note.notes.some(h => h.pitch != null && h.sticking == null))));
}
export function isMusicSheetSegment(x) {
    return x != null &&
        (isTimeSignature(x.signature)) &&
        (Array.isArray(x.measures) && x.measures.every(isMusicSheetMeasure)) &&
        (x.repeats == null || typeof x.repeats == 'number') &&
        (x.tempo == null || typeof x.tempo == 'number');
}
export function isMusicSheetMeasure(x) {
    return x != null &&
        (Array.isArray(x.notes) && x.notes.every((n) => isChord(n) || isChordTuplet(n)));
}
export function isChord(x) {
    return x != null &&
        (Array.isArray(x.duration) && x.duration.length == 2 && x.duration.every((n) => typeof n == 'number')) &&
        (Array.isArray(x.notes) && x.notes.every(isMusicNote)) &&
        (x.dots == null || typeof x.dots == 'number');
}
export function isMusicNote(x) {
    return x != null &&
        (x.pitch == null || typeof x.pitch == 'number') &&
        (x.dynamics == null || typeof x.dynamics == 'string') &&
        (x.sticking == null || typeof x.sticking == 'string') &&
        (x.lag == null || typeof x.lag == 'number');
}
export function isChordTuplet(x) {
    return x.duration != null && Array.isArray(x.duration)
        && x.chords != null && Array.isArray(x.chords)
        && x.chords.length > 0
        && x.chords.every(Array.isArray);
}
//# sourceMappingURL=MusicSheet.js.map